/**
 * Feature-flag codes (`AfriexFeature.code`) read by the server or the portals.
 *
 * The admin feature form only lets a new feature pick one of these, so a code
 * that some package checks must be listed here before its flag can be created.
 */
export var AfriexFeatureCode;
(function (AfriexFeatureCode) {
    AfriexFeatureCode["AFFILIATE_PROGRAM"] = "AFFILIATE_PROGRAM";
    AfriexFeatureCode["AFRIEX_API_CRYPTO_WALLET"] = "AFRIEX_API_CRYPTO_WALLET";
    AfriexFeatureCode["AFRIEX_API_VIRTUAL_ACCOUNT"] = "AFRIEX_API_VIRTUAL_ACCOUNT";
    AfriexFeatureCode["BULK_PAYMENT"] = "BULK_PAYMENT";
    AfriexFeatureCode["BUSINESS_AGREEMENT_SIGNING"] = "BUSINESS_AGREEMENT_SIGNING";
    AfriexFeatureCode["BUSINESS_CUSTOMERS"] = "BUSINESS_CUSTOMERS";
    AfriexFeatureCode["BUSINESS_PORTAL_PRODUCT_GUIDE"] = "BUSINESS_PORTAL_PRODUCT_GUIDE";
    AfriexFeatureCode["BUSINESS_PRICING_NEGOTIATION"] = "BUSINESS_PRICING_NEGOTIATION";
    AfriexFeatureCode["BUSINESS_TRANSACTION_EXPORT"] = "BUSINESS_TRANSACTION_EXPORT";
    AfriexFeatureCode["CHECKOUT"] = "CHECKOUT";
    AfriexFeatureCode["DARK_MODE"] = "DARK_MODE";
    AfriexFeatureCode["FORWARD_TRADE"] = "FORWARD_TRADE";
    AfriexFeatureCode["GIB_VIRTUAL_ACCOUNT"] = "GIB_VIRTUAL_ACCOUNT";
    AfriexFeatureCode["GRIDVERIFY_ENABLED"] = "GRIDVERIFY_ENABLED";
    AfriexFeatureCode["INTERAC_REQUEST_MONEY"] = "INTERAC_REQUEST_MONEY";
    AfriexFeatureCode["MAGMA_ONEPAY_VIRTUAL_ACCOUNT"] = "MAGMA_ONEPAY_VIRTUAL_ACCOUNT";
    // Multi-channel marketplace funding: bids can be paid through a virtual bank
    // account or a pool account as well as crypto. When the feature is off (or
    // no flag exists), the marketplace keeps its original crypto-only behaviour.
    AfriexFeatureCode["MARKET_PLACE_BIDIRECTIONAL"] = "MARKET_PLACE_BIDIRECTIONAL";
    AfriexFeatureCode["NOMBA_VIRTUAL_ACCOUNT"] = "NOMBA_VIRTUAL_ACCOUNT";
    AfriexFeatureCode["PAYMENT_LINQS"] = "PAYMENT_LINQS";
    AfriexFeatureCode["STRIPE_KYC_ENABLED"] = "STRIPE_KYC_ENABLED";
    AfriexFeatureCode["TEMBO_VIRTUAL_ACCOUNT"] = "TEMBO_VIRTUAL_ACCOUNT";
    AfriexFeatureCode["VIRTUAL_CARDS"] = "VIRTUAL_CARDS";
})(AfriexFeatureCode || (AfriexFeatureCode = {}));
//# sourceMappingURL=AfriexFeatureCode.js.map